@if (!isClearing && isFeatured()) {
	<uc-client-profile-sticky-lead-bar-desktop
		[uniId]="uniId()"
		[uniName]="uniName()"
		[paidFeatures]="paidFeatures()"
		[externalUrl]="externalUrl()"
		[externalEventsUrl]="externalEventsUrl()"
		[prospectusExternalUrl]="externalProspectusUrl()"
		[showClearing]="false"
		[source]="source()"
		[product]="null"
		sourceType="uni"
		[privacyPolicyUrl]="privacyPolicyUrl()"
		[ugSearchOrderPosition]="ugSearchOrderPosition()"
		[cleSearchOrderPosition]="null"
	/>
}
@if (clearingUniversity$ | async; as clearingUniversity) {
	@if (isClearing && isFeaturedClearing) {
		<uc-client-profile-sticky-lead-bar-desktop
			[uniId]="clearingUniversity.id"
			[uniName]="uniName()"
			[paidFeatures]="clearingUniversity.paid_features!"
			[externalUrl]="clearingUniversity.external_url"
			[phoneNumber]="clearingUniversity.phone_number"
			[showClearing]="true"
			[source]="clearingUniversity.name"
			product="clearing"
			sourceType="uni"
			[ugSearchOrderPosition]="null"
			[cleSearchOrderPosition]="cleSearchOrderPosition()"
		/>
	}
}
